// extracted by mini-css-extract-plugin
export default {"name":"name__14db7ac6"};